export default __webpack_public_path__ + "static/media/795.959098f8.png";